exports.flags_map = {
  "ac": "ac.png",
  "ad": "ad.png",
  "ae": "ae.png",
  "af": "af.png",
  "ag": "ag.png",
  "ai": "ai.png",
  "al": "al.png",
  "am": "am.png",
  "ao": "ao.png",
  "aq": "aq.png",
  "ar": "ar.png",
  "as": "as.png",
  "at": "at.png",
  "au": "au.png",
  "aw": "aw.png",
  "ax": "ax.png",
  "az": "az.png",
  "ba": "ba.png",
  "bb": "bb.png",
  "bd": "bd.png",
  "be": "be.png",
  "bf": "bf.png",
  "bg": "bg.png",
  "bh": "bh.png",
  "bi": "bi.png",
  "bj": "bj.png",
  "bl": "bl.png",
  "bm": "bm.png",
  "bn": "bn.png",
  "bo": "bo.png",
  "bq": "bq.png",
  "br": "br.png",
  "bs": "bs.png",
  "bt": "bt.png",
  "bv": "bv.png",
  "bw": "bw.png",
  "by": "by.png",
  "bz": "bz.png",
  "ca": "ca.png",
  "cc": "cc.png",
  "cd": "cd.png",
  "cefta": "cefta.png",
  "cf": "cf.png",
  "cg": "cg.png",
  "ch": "ch.png",
  "ci": "ci.png",
  "ck": "ck.png",
  "cl": "cl.png",
  "cm": "cm.png",
  "cn": "cn.png",
  "co": "co.png",
  "cp": "cp.png",
  "cr": "cr.png",
  "cu": "cu.png",
  "cv": "cv.png",
  "cw": "cw.png",
  "cx": "cx.png",
  "cy": "cy.png",
  "cz": "cz.png",
  "de": "de.png",
  "dg": "dg.png",
  "dj": "dj.png",
  "dk": "dk.png",
  "dm": "dm.png",
  "do": "do.png",
  "dz": "dz.png",
  "ea": "ea.png",
  "ec": "ec.png",
  "ee": "ee.png",
  "eg": "eg.png",
  "eh": "eh.png",
  "er": "er.png",
  "es": "es.png",
  "es-ct": "es-ct.png",
  "es-ga": "es-ga.png",
  "es-pv": "es-pv.png",
  "et": "et.png",
  "eu": "eu.png",
  "fi": "fi.png",
  "fj": "fj.png",
  "fk": "fk.png",
  "fm": "fm.png",
  "fo": "fo.png",
  "fr": "fr.png",
  "ga": "ga.png",
  "gb": "gb.png",
  "gb-eng": "gb-eng.png",
  "gb-nir": "gb-nir.png",
  "gb-sct": "gb-sct.png",
  "gb-wls": "gb-wls.png",
  "gd": "gd.png",
  "ge": "ge.png",
  "gf": "gf.png",
  "gg": "gg.png",
  "gh": "gh.png",
  "gi": "gi.png",
  "gl": "gl.png",
  "gm": "gm.png",
  "gn": "gn.png",
  "gp": "gp.png",
  "gq": "gq.png",
  "gr": "gr.png",
  "gs": "gs.png",
  "gt": "gt.png",
  "gu": "gu.png",
  "gw": "gw.png",
  "gy": "gy.png",
  "hk": "hk.png",
  "hm": "hm.png",
  "hn": "hn.png",
  "hr": "hr.png",
  "ht": "ht.png",
  "hu": "hu.png",
  "ic": "ic.png",
  "id": "id.png",
  "ie": "ie.png",
  "il": "il.png",
  "im": "im.png",
  "in": "in.png",
  "io": "io.png",
  "iq": "iq.png",
  "ir": "ir.png",
  "is": "is.png",
  "it": "it.png",
  "je": "je.png",
  "jm": "jm.png",
  "jo": "jo.png",
  "jp": "jp.png",
  "ke": "ke.png",
  "kg": "kg.png",
  "kh": "kh.png",
  "ki": "ki.png",
  "km": "km.png",
  "kn": "kn.png",
  "kp": "kp.png",
  "kr": "kr.png",
  "kw": "kw.png",
  "ky": "ky.png",
  "kz": "kz.png",
  "la": "la.png",
  "lb": "lb.png",
  "lc": "lc.png",
  "li": "li.png",
  "lk": "lk.png",
  "lr": "lr.png",
  "ls": "ls.png",
  "lt": "lt.png",
  "lu": "lu.png",
  "lv": "lv.png",
  "ly": "ly.png",
  "ma": "ma.png",
  "mc": "mc.png",
  "md": "md.png",
  "me": "me.png",
  "mf": "mf.png",
  "mg": "mg.png",
  "mh": "mh.png",
  "mk": "mk.png",
  "ml": "ml.png",
  "mm": "mm.png",
  "mn": "mn.png",
  "mo": "mo.png",
  "mp": "mp.png",
  "mq": "mq.png",
  "mr": "mr.png",
  "ms": "ms.png",
  "mt": "mt.png",
  "mu": "mu.png",
  "mv": "mv.png",
  "mw": "mw.png",
  "mx": "mx.png",
  "my": "my.png",
  "mz": "mz.png",
  "na": "na.png",
  "nc": "nc.png",
  "ne": "ne.png",
  "nf": "nf.png",
  "ng": "ng.png",
  "ni": "ni.png",
  "nl": "nl.png",
  "no": "no.png",
  "np": "np.png",
  "nr": "nr.png",
  "nu": "nu.png",
  "nz": "nz.png",
  "om": "om.png",
  "pa": "pa.png",
  "pe": "pe.png",
  "pf": "pf.png",
  "pg": "pg.png",
  "ph": "ph.png",
  "pk": "pk.png",
  "pl": "pl.png",
  "pm": "pm.png",
  "pn": "pn.png",
  "pr": "pr.png",
  "ps": "ps.png",
  "pt": "pt.png",
  "pw": "pw.png",
  "py": "py.png",
  "qa": "qa.png",
  "re": "re.png",
  "ro": "ro.png",
  "rs": "rs.png",
  "ru": "ru.png",
  "rw": "rw.png",
  "sa": "sa.png",
  "sb": "sb.png",
  "sc": "sc.png",
  "sd": "sd.png",
  "se": "se.png",
  "sg": "sg.png",
  "sh": "sh.png",
  "si": "si.png",
  "sj": "sj.png",
  "sk": "sk.png",
  "sl": "sl.png",
  "sm": "sm.png",
  "sn": "sn.png",
  "so": "so.png",
  "sr": "sr.png",
  "ss": "ss.png",
  "st": "st.png",
  "sv": "sv.png",
  "sx": "sx.png",
  "sy": "sy.png",
  "sz": "sz.png",
  "ta": "ta.png",
  "tc": "tc.png",
  "td": "td.png",
  "tf": "tf.png",
  "tg": "tg.png",
  "th": "th.png",
  "tj": "tj.png",
  "tk": "tk.png",
  "tl": "tl.png",
  "tm": "tm.png",
  "tn": "tn.png",
  "to": "to.png",
  "tr": "tr.png",
  "tt": "tt.png",
  "tv": "tv.png",
  "tw": "tw.png",
  "tz": "tz.png",
  "ua": "ua.png",
  "ug": "ug.png",
  "um": "um.png",
  "un": "un.png",
  "us": "us.png",
  "uy": "uy.png",
  "uz": "uz.png",
  "va": "va.png",
  "vc": "vc.png",
  "ve": "ve.png",
  "vg": "vg.png",
  "vi": "vi.png",
  "vn": "vn.png",
  "vu": "vu.png",
  "wf": "wf.png",
  "ws": "ws.png",
  "xk": "xk.png",
  "xx": "xx.png",
  "ye": "ye.png",
  "yt": "yt.png",
  "za": "za.png",
  "zm": "zm.png",
  "zw": "zw.png"
}
